import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClientService } from '../../shared/services/http-client.service';
import { CampanhaPerfil } from '../../core/interface/campanha';
import { PerfilInvestidor } from '../../core/interface/perfil-investidor';
import { CommonModule } from '@angular/common';
import { PerfilParticipante } from '../../core/interface/perfil-participante';
import { EnumStatus } from '../../core/enum/EnumStatus';
import { AppStateService } from '../../shared/services/app-state.service';
import { EnumStatusResponse } from '../../core/enum/EnumHttpResponse';
import { SummaryCardComponent } from '../../shared/components/summary-card/summary-card.component';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastService } from '../../shared/services/toast.service';
import { ExcluirRespostasPayload, QuestionarioRespondido } from '../../core/interface/questionario';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, SummaryCardComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class Home implements OnInit {
  token: string = '';
  isStatusConcluido: boolean = false;
  perfil: string = '';
  dateEndCampaign: string = '';
  dateNow = new Date();

  EnumStatus = EnumStatus;
  campanha!: CampanhaPerfil;
  perfilParticipante!: PerfilParticipante;
  perfisInvestidor: PerfilInvestidor[] = [];

  questionarioRespondido!: QuestionarioRespondido[];

  constructor(
    private router: Router,
    private httpClientService: HttpClientService,
    private appStateService: AppStateService,
    private loaderService: LoaderService,
    private toastService: ToastService
  ) { 
  }

  ngOnInit(): void {
    this.token = this.appStateService.getToken()!;
    const campanha = this.appStateService.getCampanha();
    const perfilParticipante = this.appStateService.getPerfilParticipante();

    if (!campanha || !perfilParticipante) {
      console.warn('Home carregado sem estado completo:', { campanha, perfilParticipante });
      this.router.navigate(['/not-found']);
      return;
    }

    this.campanha = campanha;
    this.perfilParticipante = perfilParticipante;
    this.getQuestionnaireParticipante(this.token, this.perfilParticipante.id);

    if (this.campanha.idCampanha) {
      this.getPerfisInvestidor(this.token, this.campanha.idCampanha);
    }

    this.dateEndCampaign = this.formatarData(this.campanha.dtaFim);
  }

  formatarData(data?: string) {
    if (!data) return "";

    const partes = data.split("-");
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  goToQuestionnaire(): void {
    // Salva o perfil participante
    this.appStateService.setPerfilParticipante(this.perfilParticipante);

    this.router.navigate(['questionnaire']);
  }

  statusConcluido(): boolean {
    return this.isStatusConcluido = this.perfilParticipante.status === EnumStatus.Finalizado ? true : false;
  }
  
  private getPerfisInvestidor(token: string, idCampanha: number): void {
    this.loaderService.showLoader();
    this.httpClientService.getPerfisInvestidor(token, idCampanha)
      .then(response => {
        if (response.status === EnumStatusResponse.Success && response.body) {
          this.perfisInvestidor = response.body as PerfilInvestidor[];
          this.appStateService.setPerfisInvestimento(this.perfisInvestidor);
        }
      })
      .catch(error => {
        console.error('Perfis de investidor não encontrados.');
      })
      .finally(() => this.loaderService.hideLoader());
  }

  private getQuestionnaireParticipante(token: string, idParticipante: number): void {
      this.loaderService.showLoader();
      this.httpClientService.getQuestionnaireParticipante(token, idParticipante)
        .then(response => {
          if (response.status !== EnumStatusResponse.Success || !response.body) {
            return;
          }
          const questionarioRespondido = response.body as QuestionarioRespondido[];
          this.questionarioRespondido = questionarioRespondido;

          if(questionarioRespondido.length > 0) {
            this.deletedQuestionnaire(token, idParticipante, { ids: questionarioRespondido.map(q => q.idRespostaPartic) });
          }

        })
        .catch(error => {
          console.error(
            'Erro ao carregar os questionários do participante:',
            error
          );
          this.toastService.show('Não foi possível carregar os questionários do participante.', 'error');
        })
        .finally(() => this.loaderService.hideLoader());
    }
  
    private deletedQuestionnaire(token: string, idParticipante: number, payload: ExcluirRespostasPayload): void {
      this.loaderService.showLoader();
      this.httpClientService.deletedQuestionnaire(token, idParticipante, payload)
        .then(response => {
          if (response.status !== EnumStatusResponse.Success || !response.body) {
            return;
          }
        })
        .catch(error => {
          console.error(
            'Erro ao deletar o questionário do participante:',
            error
          );
          this.toastService.show('Não foi possível deletar o questionário do participante.', 'error');
        })
        .finally(() => this.loaderService.hideLoader());
    }
}
